import { getTransactions } from "@/api/collectionOrder";
import { useState, useEffect } from "react";

const useTransactions = (id: string) => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await getTransactions(id);
        console.log(response);
        setTransactions(response);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching transactions:", error);
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [id]);

  return { transactions, loading };
};

export default useTransactions;
